export const ColourSchemas = {
  primary: 'primary',
  secondary: 'secondary',
  gosScheme: 'gos-scheme',
} as const;

export type ColourSchemaValue =
  (typeof ColourSchemas)[keyof typeof ColourSchemas];

export interface IColourSchema {
  id: number;
  name: ColourSchemaValue;
}
